import GeneralModal from './GeneralModal'
import { useEffect, useState } from 'react'
import TextInput from '../TextInput/TextInput'

const CreateModal = ({ isOpen, onRequestClose, title, label, onSubmit }) => {
  const [value, setValue] = useState('')
  useEffect(() => {
    setValue('')
  }, [isOpen])

  function handleEnter() {
    if (value) {
      handleSubmit()
    }
  }

  function handleSubmit() {
    onSubmit(value)
    onRequestClose()
  }
  return (
    <GeneralModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={title}
      buttons={[
        {
          className: 'button bg-pink',
          text: 'Create',
          disabled: !value,
          onClick: handleSubmit,
        },
      ]}
    >
      <TextInput
        label={label}
        value={value}
        name="name"
        onChange={(evt) => setValue(evt.target.value)}
        onEnter={handleEnter}
      />
    </GeneralModal>
  )
}

export default CreateModal
